export default {
  viewBox: "0 0 24 24",
  paths: [
    "M11 24L11 2L13 2L13 24L11 24Z",
    "M18 6.61667L16.7458 8L12 2.76478L7.25423 8L6 6.61667L12 -2.62269e-07L18 6.61667Z"
  ]
};